import React from 'react'
import { Button, Card, Empty, Input, Tag, Typography } from 'antd'
import menuBuilderMenusCopy from 'src/constants/menuBuilderCopy'

const { Text, Paragraph } = Typography

const gpBadgeStyle = {
  margin: 0,
  color: '#237804',
  background: '#f6ffed',
  borderColor: '#b7eb8f',
}

const SalesMixGpBadge = ({ gp }) => (
  <Tag style={gpBadgeStyle}>
    {menuBuilderMenusCopy.salesMixRecipeGpLabel.replace('{gp}', String(gp))}
  </Tag>
)

const MenuSalesMixPanel = ({
  recipes = [],
  qtyByRecipe = {},
  preview = {},
  onQtyChange,
  onSave,
  saving = false,
  disabled = false,
}) => {
  const copy = menuBuilderMenusCopy
  const {
    hasSalesMix = false,
    weightedGp = null,
    estimatedTotalGpLabel = null,
  } = preview

  if (recipes.length === 0) {
    return (
      <div style={{ padding: '8px 0' }}>
        <Paragraph style={{ marginBottom: 8 }}>
          {copy.salesMixExplainer}
        </Paragraph>
        <Text type='secondary' style={{ display: 'block', marginBottom: 16 }}>
          {copy.salesMixPeriodNote}
        </Text>
        <Empty
          description={copy.salesMixNoRecipes}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    )
  }

  return (
    <div style={{ padding: '8px 0' }}>
      <Paragraph style={{ marginBottom: 8 }}>
        {copy.salesMixExplainer}
      </Paragraph>
      <Text type='secondary' style={{ display: 'block', marginBottom: 12 }}>
        {copy.salesMixPeriodNote}
      </Text>

      <Card
        size='small'
        style={{ marginBottom: 12, background: '#fafafa' }}
        bodyStyle={{ padding: 12 }}
      >
        <Text strong style={{ display: 'block', marginBottom: 6 }}>
          {copy.salesMixHelpTitle}
        </Text>
        <Paragraph style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>
          {copy.salesMixAvgGpHelp}
        </Paragraph>
        <Paragraph style={{ marginBottom: 0, fontSize: 12, color: '#666' }}>
          {copy.salesMixWeightedGpHelp}
        </Paragraph>
      </Card>

      <Card
        size='small'
        style={{ marginBottom: 16 }}
        bodyStyle={{ padding: 12 }}
      >
        {hasSalesMix ? (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 8,
              }}
            >
              <Text>{copy.salesMixWeightedGpLabel}</Text>
              <Text strong>{weightedGp != null ? `${weightedGp}%` : '—'}</Text>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Text>{copy.salesMixTotalGpLabel}</Text>
              <Text strong>
                {estimatedTotalGpLabel ? `£${estimatedTotalGpLabel}` : '—'}
              </Text>
            </div>
          </>
        ) : (
          <Text type='secondary'>{copy.salesMixEmptyQtyHint}</Text>
        )}
      </Card>

      {recipes.map(recipe => {
        const qtyValue = qtyByRecipe[recipe.id] ?? ''

        return (
          <Card
            key={recipe.id}
            size='small'
            style={{ marginBottom: 12 }}
            bodyStyle={{ padding: 12 }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 12,
                marginBottom: 10,
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <Text strong style={{ display: 'block' }}>
                  {recipe.title}
                </Text>
                {recipe.sectionName ? (
                  <Text type='secondary' style={{ fontSize: 12 }}>
                    {recipe.sectionName}
                  </Text>
                ) : null}
              </div>
              {recipe.hasPricing && recipe.gpPercent != null ? (
                <SalesMixGpBadge gp={recipe.gpPercent} />
              ) : (
                <Text
                  type='secondary'
                  style={{
                    fontSize: 11,
                    lineHeight: '15px',
                    maxWidth: '46%',
                    textAlign: 'right',
                  }}
                >
                  {copy.salesMixMissingPriceHint}
                </Text>
              )}
            </div>

            <div>
              <Text style={{ display: 'block', marginBottom: 6, fontSize: 12 }}>
                {copy.salesMixQtyLabel}
              </Text>
              <Input
                value={qtyValue}
                onChange={event => onQtyChange?.(recipe.id, event.target.value)}
                placeholder={copy.salesMixQtyPlaceholder}
                disabled={disabled}
              />
            </div>
          </Card>
        )
      })}

      {onSave ? (
        <Button
          type='primary'
          block
          onClick={onSave}
          loading={saving}
          disabled={disabled || saving}
          style={{
            marginTop: 4,
            backgroundColor: disabled || saving ? undefined : '#b5d922',
            borderColor: disabled || saving ? undefined : '#b5d922',
            color: disabled || saving ? undefined : '#000',
          }}
        >
          {saving ? copy.salesMixSavingCta : copy.salesMixSaveCta}
        </Button>
      ) : null}
    </div>
  )
}

export default MenuSalesMixPanel
